import { render } from "./mvt-authenticate.vue?vue&type=template&id=8e20e748"
import script from "./mvt-authenticate.js?vue&type=script&lang=js"
export * from "./mvt-authenticate.js?vue&type=script&lang=js"

import "./mvt-authenticate.vue?vue&type=style&index=0&id=8e20e748&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__